









































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
// import GuiStyle from '@/utils/GuiStyle';

// const event = namespace('event');

@Component
export default class WidgetCard extends Vue {

  @Prop({ type: Boolean, default: false }) protected offsetIcon!: boolean;
  @Prop({ type: Boolean, default: false }) protected fullWidth?: boolean;
  @Prop({ type: [Number, String], default: 24 }) protected offset!: number | string;
  @Prop({ type: Boolean, default: false }) protected alignCenter?: boolean;
  @Prop({ type: Boolean, default: false }) protected offsetDense?: boolean;
  @Prop({ type: String, default: '100%' }) protected maxWidth?: string;
  @Prop({ type: String, default: 'inherit' }) protected width?: string;
  // @Prop({ type: Boolean, default: false }) protected isDefaultOffsetColor?: boolean;
  @Prop({ type: String, default: 'default' }) protected offsetEventCode?: string;

  @Prop({ type: Boolean, default: false }) protected hideHeader?: boolean;

  // @event.State('mvk') protected eventMvk: any;
  // @event.Getter('defaultColor') protected eventDefaultColor: any;
  // @event.Getter('defaultCode') protected eventDefaultCode: any;
  // protected get eventColor() {
  //   return this.eventMvk && this.eventMvk.color ? this.eventMvk.color : this.eventDefaultColor;
  // }
  // protected get eventCode() {
  //   return this.eventMvk && this.eventMvk.code ? this.eventMvk.code : this.eventDefaultCode;
  // }

  // protected get eventCssClass() {
  //   if (this.offsetEventCode != 'default') return `ex--${this.offsetEventCode}`;
  //   return this.isDefaultOffsetColor ? "ex--default" : `ex--${this.eventCode}`;
  // }

  protected get hasOffset() {
    return this.$slots.header ||
      this.$slots.offset;
  }

  protected get styles() {

    // if (!this.hasOffset) { return null; }

    return {
      marginBottom: `${this.offset}px`,
      marginTop: `${this.offset as number}px`,
      maxWidth: `${this.maxWidth}!important`,
      width: `${this.width}`,
    };

  }

  protected get offsetStyle() {

    let style = {} as any;

    if (this.offsetDense) {

      style.padding = '10px';

    }

    return style;

  }

}

